<template>
  <a
    :href="href"
    :target="target"
    :rel="rel"
    :aria-label="ariaLabel"
    :role="role"
    :tabindex="tabindex"
    v-on="$listeners"
    v-bind="$attrs"
    :title="computedTitle"
    data-info="BaseLink Component"
  >
    <slot></slot>
  </a>
</template>

<script>
export default {
  name: "BaseLink",
  inheritAttrs: false,
  props: {
    href: { type: String, required: true },
    ariaLabel: { type: String, required: false, default: null },
    role: { type: String, required: false, default: "link" },
    tabindex: { type: [String, Number], required: false, default: 0 },
    target: { type: String, required: false, default: "_self" },
    rel: { type: String, required: false, default: null },
    title : { type: String, required: false, default: ""}
  },
   computed: {
    computedTitle() {
      return this.title || this.ariaLabel || undefined;
    }
  },
  mounted() {
    if (this.target === "_blank" && !this.rel) {
      this.$el.setAttribute("rel", "noopener noreferrer");
    }
  }
};
</script>
